module.exports = __webpack_public_path__ + "static/media/checkbox.6ec58feb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/checkbox.svg
// module id = 194
// module chunks = 0